export default "__VITE_ASSET__14748049__"